export default [
  {
    path: 'dashboard',
    view: 'site/Dashboard',
    title: 'Dashboard',
  },
  {
    path: 'reports/trends',
    view: 'site/Reports',
    title: 'Reports',
  },
  {
    path: 'reports/dispense-logs',
    view: 'site/DispenseLogs',
    title: 'Dispense Logs',
  },
  {
    path: 'reports/consumption',
    view: 'site/ConsumptionReports',
    title: 'Consumption Report',
  },
  {
    path: 'allocation-units',
    view: 'site/AllocationUnits',
    title: 'Allocation Units',
  },
  {
    path: 'chemicals',
    view: 'site/ChemicalCosts',
    title: 'Chemicals',
  },
  {
    path: 'applications',
    view: 'site/Applications',
    title: 'Applications',
  },
  {
    path: 'users',
    view: 'site/WebUsers',
    title: 'Web Users',
  },
  {
    path: 'plant-users',
    view: 'site/PlantUsers',
    title: 'Plant Users',
  },
  {
    path: 'email-reports',
    view: 'site/Subscriptions',
    title: 'Email Reports',
  },
  {
    path: 'users/create',
    view: 'single/UserCreate',
    name: 'Site Create User',
    title: 'Create User',
  },
  {
    path: 'users/:resource_id',
    view: 'single/UserEdit',
    name: 'Site User Edit',
    title: 'Edit User',
  },
  {
    path: 'plant-users/create',
    view: 'single/PlantUserCreate',
    title: 'Create Plant User',
  },
  {
    path: 'plant-users/:resource_id',
    view: 'single/PlantUserEdit',
    title: 'Edit Plant User',
  },
  {
    path: 'allocation-units/create',
    view: 'single/AllocationUnitCreate',
    name: 'Site Create Allocation Unit',
    title: 'Create Allocation Unit',
  },
  {
    path: 'allocation-units/:resource_id',
    view: 'single/AllocationUnitEdit',
    name: 'Site User Allocation Unit',
    title: 'Edit Allocation Unit',
  },
  {
    path: 'chemicals/create',
    view: 'single/ChemicalCostCreate',
    title: 'Create Chemical',
  },
  {
    path: 'chemicals/:resource_id',
    view: 'single/ChemicalCostEdit',
    title: 'Edit Chemical',
  },
  {
    path: 'email-reports/create',
    view: 'single/SubscriptionCreate',
    name: 'Create Site Subscription',
    title: 'Create Subscription',
  },
  {
    path: 'email-reports/:resource_id',
    view: 'single/SubscriptionEdit',
    name: 'Edit Site Subscription',
    title: 'Edit Subscription',
  },
  {
    path: 'applications/create',
    view: 'single/ApplicationCreate',
    title: 'Create Application',
  },
  {
    path: 'applications/:resource_id',
    view: 'single/ApplicationEdit',
    title: 'Edit Application',
  },
];
